















import {Component, Ref, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
// @ts-ignore
import * as firebase from 'firebase/app';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

const userNamespace = namespace('userState');

@Component({
  components: {
    BButton,
  },
})

export default class OnlineSafetyModal extends Vue {
  @userNamespace.State('self') public myself!: MAFUser;
  @userNamespace.Action('purchase') public purchase: any;
  @userNamespace.Action('giftCoinsToSelf') public giftCoinsToSelf!: any;
  @userNamespace.Action('updateUser') public updateUser!: any;

  public isLoading: boolean = false;
  public iosUrl: string = '';
  public androidUrl: string = '';

  public async created() {
    await this.getAppUrls();
  }

  public async download() {
    this.myself.newMobile = true;

    if (this.myself.Reference) {
      try {
          return await this.myself.Reference.update(this.myself.toPlainObj());
      } catch (error) {
          console.log(error);
          return error;
      }
    } else {
      const selfDocumentRef = Vue.prototype.$firestore.collection('users').doc(this.myself.uid);
      selfDocumentRef.set(this.myself.toPlainObj(), {merge: true});
      this.updateUser(this.myself);
    }

    this.closeSafetyModal();
  }

  // public async download(typeUrl) {
  //   this.myself.newMobile = true;

  //   if (typeUrl) {
  //     window.open(typeUrl, '_blank')
  //   }

  //   if (this.myself.Reference) {
  //     try {
  //         return await this.myself.Reference.update(this.myself.toPlainObj());
  //     } catch (error) {
  //         console.log(error);
  //         return error;
  //     }
  //   } else {
  //     const selfDocumentRef = Vue.prototype.$firestore.collection('users').doc(this.myself.uid);
  //     selfDocumentRef.set(this.myself.toPlainObj(), {merge: true});
  //     this.updateUser(this.myself);
  //   }

  //   this.closeSafetyModal();
  // }

  public async getAppUrls() {
    await this.$firestore.collection('appstore')
      .get().then((snapshot) => {
        // get all signed up users within a specific geohash range
        snapshot.docs.forEach((document) => {
          if (document.data().ios) {
            this.iosUrl = document.data().ios;
          } else if (document.data().android) {
            this.androidUrl = document.data().android;
          }
        });
      });
  }

  @Emit('close')
  public closeSafetyModal() {}
}
